




















































// vendor
import { defineComponent, computed, ref } from "@vue/composition-api";

export default defineComponent({

	setup(){

		const modal = ref<Modal>();
		const input = ref<HTMLInputElement>();
		const value = ref<string>("");
		const onDone = ref<DoneHandler>();
		const show = ref(false);
		const oldValue = ref<string>("");

		const canSave = computed(() => oldValue.value !== value.value);

		const ok = () => {
			if(onDone.value){
				onDone.value(value.value);
			}
			if(modal.value){
				modal.value.hide();
			}
		};

		const hide = () => {
			onDone.value = undefined;
			show.value = false;
			value.value = "";
			oldValue.value = "";
		};

		const open = (config:Config, fn:DoneHandler) => {
			onDone.value = fn;
			show.value = true;
			value.value = config.value;
			oldValue.value = config.value;
			const i = input.value;
			if(i){
				setTimeout(() => i.select(), 1);
			}
		};

		return {
			modal,
			input,
			value,
			show,
			oldValue,
			canSave,
			ok,
			hide,
			open
		};
	}

});

type Modal = {
	hide():void
}


type Config = {
	value:string
}

type DoneHandler = (v:string) => void;


